import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AuthorizationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AuthorizationQuery = { __typename?: 'Query', me?: { __typename?: 'AuthenticatedUser', id: string } | { __typename?: 'IdentifiedUser', id: string } | null };


export const Authorization = /*#__PURE__*/ gql`
    query Authorization {
  me {
    id
  }
}
    ` as unknown as DocumentNode<AuthorizationQuery, AuthorizationQueryVariables>;

          

          export const useAuthorizationQuery = (options?:QueryHookOptions<AuthorizationQuery, AuthorizationQueryVariables>) => useQuery(Authorization, options);

          

          export type AuthorizationQueryOptions = QueryHookOptions<AuthorizationQuery, AuthorizationQueryVariables>;

          

          export const useAuthorizationLazyQuery = (options?:LazyQueryHookOptions<AuthorizationQuery, AuthorizationQueryVariables>) => useLazyQuery(Authorization, options);

          

          export type AuthorizationQueryResult = ReturnType<typeof useAuthorizationQuery>;

          
